import React from 'react';
import PropTypes from 'prop-types';
import RaceCardFooter from './RaceCardFooter';
import TimeformTip from './TimeformTip';

import {
    BB_RACING_WIDGET_RACECARD_CLASS,
    BB_RACING_WIDGET_CLASS,
} from '../../constants';

import BetCard from '../../../../shared/components/react/BetCard/index';
import {
    shouldWeDisplaySpIfNotTradable,
    shouldSelectionBeBetableIfNotTradable,
    getSilkOrTrapInlineStyle,
} from '~scenes/sport/horse-racing/utils';

const propTypes = {
    timeformEvents: PropTypes.object,
    timeformSelections: PropTypes.object,
    selections: PropTypes.array,
    type: PropTypes.string,
    typeCode: PropTypes.string,
    isLoading: PropTypes.bool,
    eventId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    source: PropTypes.string,
    events: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
    ]),
    tournamentsDetails: PropTypes.object,
};

const RaceCards = (props) => {
    const getCountryCode = () => {
        const { eventId, tournamentsDetails } = props;
        const tournamentId = props.events[eventId].details.tournament_id;

        return tournamentsDetails[tournamentId]?.country_code || null;
    };

    const getDescription = (selection) => {
        const timeformSelections = props.timeformSelections[selection.id];
        const recentForm = timeformSelections ? timeformSelections.recent_form : null;
        const style = getSilkOrTrapInlineStyle(props.type, selection, getCountryCode(), props.typeCode);
        const { name, jockey, trainer, cloth_number } = selection;
        const isTrotting = props.type === 'trotting';

        return (
            <>
                {isTrotting ? (
                    <div className={`${BB_RACING_WIDGET_CLASS}__cloth`}>
                        {cloth_number}
                    </div>
                ) : (
                    <div
                        className={`${BB_RACING_WIDGET_CLASS}__selection`}
                        style={style}
                    ></div>
                )}
                <div className={`${BB_RACING_WIDGET_CLASS}__container`}>
                    <div className={`${BB_RACING_WIDGET_CLASS}__content`}>
                        <strong className={`${BB_RACING_WIDGET_CLASS}__content-name`}>
                            {name}
                        </strong>

                        <div className={`${BB_RACING_WIDGET_CLASS}__content-selections`}>
                            {jockey && (
                                <span>
                                    J: {jockey}
                                </span>
                            )}
                            {trainer && (
                                <span>
                                    T: {trainer}
                                </span>
                            )}
                        </div>
                    </div>
                    {recentForm && (
                        <div className={`${BB_RACING_WIDGET_CLASS}__recentform`}>
                            F: {recentForm}
                        </div>
                    )}
                </div>
            </>
        );
    };

    const { selections, isLoading, type, eventId, events } = props;
    if (!selections || isLoading) {
        return null;
    }

    const betCards = selections.map((originalSelection, key) => {
        const selection = {
            ...originalSelection,
            betable: shouldSelectionBeBetableIfNotTradable(type, eventId, events, originalSelection),
            sp_only: shouldWeDisplaySpIfNotTradable(type, originalSelection),
        };

        const gtmAttribute = `${props.source};${props.type}-widget;`;
        const betCardProps = {
            description: getDescription(selection),
            selections: [selection],
            betable: selection.betable,
            price: selection.decimal_price,
            gtmAttribute,
        };

        return (
            <BetCard key={`${key}_${eventId}`} {...betCardProps} />
        );
    });

    return (
        <div className={BB_RACING_WIDGET_RACECARD_CLASS}>
            <TimeformTip {...props} />
            {betCards}
            <RaceCardFooter {...props} />
        </div>
    );
};

RaceCards.propTypes = propTypes;

export default RaceCards;
